<template>
  <div>
    <div class="connect-channel-container">
      <div class="channel-header">
        <div class="step-content">
          <!-- Progress Steps -->
          <div class="progress-container">
            <div class="steps">
              <div class="step" :class="currentStep === 1 ? 'selected' : ''">
                <div class="number">1</div>
                <div class="text">Sign in</div>
              </div>
              <div class="divider">
              </div>
              <div class="step" :class="currentStep === 2 ? 'selected' : ''">
                <div class="number">2</div>
                <div class="text">Link account</div>
              </div>
              <div class="divider">
              </div>
              <div class="step" :class="currentStep === 3 ? 'selected' : ''">
                <div class="number">3</div>
                <div class="text">Complete</div>
              </div>
            </div>
          </div>
          <div class="content-col">
            <!-- Step 1: API Key details -->
            <div v-if="currentStep === 1" class="step-content-section">
              <div class="flex-center headerContainer">
                <div>
                  <h1 class="vtext-card-title text-center vpb-10">Sign in</h1>
                  <p class="vtext-subtitle">Please enter your details.</p>
                </div>
              </div>
              <div class="sectionPadding">
                <div class="marginBottom">
                  <p class="vtext-subtitle vpb-10">API key<span class="important">*</span></p>
                  <VTextField v-model="apikey" placeholder="Enter API key" aria-label="API key" appearance="ghost" class="vivid-input" autocomplete="off"></VTextField>
                </div>
                <div>
                  <p class="vtext-subtitle vpb-10">API secret<span class="important">*</span></p>
                  <div class="password-input-container">
                    <VTextField v-model="apisecret" placeholder="Enter API secret" :type="showApiSecret ? 'text' : 'password'" aria-label="API secret" appearance="ghost" class="vivid-input password-input" autocomplete="new-password"></VTextField>
                    <VIcon :name="showApiSecret ? 'eye-hide-line' : 'eye-line'" class="toggle-visibility-btn cursorPointer" @click="toggleApiSecretVisibility"></VIcon>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 2: Configuration -->
            <div v-if="currentStep === 2" class="step-content-section">
              <div v-if="showFlowChart !== true">
                <div class="flex-center headerContainer">
                  <div>
                    <h1 class="vtext-card-title text-center vpb-10">Select account</h1>
                    <p class="vtext-subtitle">Please select the account to link.</p>
                  </div>
                </div>
                <div class="accounts-container sectionPadding">
                  <div v-for="(account, index) in accounts" :key="index" class="account-card" :class="{ 'selected': account.selected }" @click="selectAccount(index)" >
                    <div class="account-info">
                      <div class="account-row">
                        <span class="sub-title">Name</span>
                        <span class="sub-title">ID</span>
                        <span class="sub-title">Status</span>
                      </div>
                      <div class="account-details">
                        <span class="name">{{ account.name }}</span>
                        <span class="id">{{ account.id }}</span>
                        <span class="status" v-if="account.status === true">Linked to application</span>
                        <span class="status" v-if="account.status === false">Not linked</span>
                      </div>
                    </div> 
                    <div class="radio-container">
                      <VIcon :name="account.selected ? 'radio-checked-line' : 'radio-unchecked-line'" :connotation="account.selected ? 'cta' : undefined"></VIcon>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="showFlowChart" class="flowchart-container">
                <div class="leftside-container">
                  <div class="box account-name">
                    {{selectedAccount.name}}
                  </div>

                  <div class="line1"></div>
                </div>
                <div class="rightside-container">
                  <div>
                    <div class="box current-app">
                      Current Application
                    </div>

                    <div class="line2"></div>
                    <div class="warning">x</div>
                    <div class="line3"></div>
                  </div>
                  <div>
                    <div class="box application">
                      This application
                    </div>

                    <div class="line4"></div>
                    <div class="line5"></div>
                  </div>
                </div>

                <!-- Question Text -->
                <div class="question-text">
                  <div>
                    <h1 class="vtext-card-title text-center vpb-10">Are you sure?</h1>
                    <p class="vtext-subtitle text-center">An external account can only be linked to one application at a time. If you choose to link it to a new application, it will automatically be unlinked from the current one.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Step 3: Review & Connect -->
            <div v-if="currentStep === 3" class="step-content-section">
              <div class="cust-brdr brdr_top sectionPadding">
                <div class="flex-start alignCenter gap10P">
                  <img v-if="channelType === 'google-rcs'" src="@/resources/images/Google_RCS_icon.svg" alt="Google RCS" width="40"/>
                  <img v-if="channelType === 'whatsapp'" src="@/resources/images/whatsapp-logo.svg" alt="WhatsApp" width="40"/>
                  <img v-if="channelType === 'sms'" src="@/resources/images/sms_logo.svg" alt="SMS" width="40"/>
                  <div>
                    <p class="vtext-card-title">{{selectedAccount.name}}</p>
                  </div>
                </div>
              </div>
              <div class="sectionPadding">
                <div class="flex-between custPaddingBottom">
                  <p class="vtext-subtitle">ID</p>
                  <h2 class="vtext-card-title--light">{{ channelType === 'whatsapp' ?  selectedAccount.linknumber : selectedAccount.name }}</h2>
                </div> 
                <div class="flex-between custPaddingBottom">
                  <p class="vtext-subtitle">App ID</p>
                  <h2 class="vtext-card-title--light">{{selectedAccount.appid}}</h2>
                </div> 
                <div class="flex-between custPaddingBottom">
                  <p class="vtext-subtitle">API Key</p>
                  <h2 class="vtext-card-title--light">{{apikey}}</h2>
                </div> 
              </div>
            </div>
          </div>
        </div> 
        <!-- Navigation Buttons -->
        <div class="navigation-section sectionPadding">
          <div class="navigation-buttons flex-between">
            <VButton v-if="currentStep > 1 && currentStep !== 3" class="vvd-btn-cancel flex100P" appearance="filled" label="Previous" @click="previousStep"></VButton>
            <VButton v-else-if="currentStep === 1" class="vvd-btn-cancel flex100P" appearance="filled" label="Previous" @click="goBackToSelection"></VButton>
            <VButton class="vvd-btn-primary flex100P" connotation="cta" appearance="filled" :label="currentStep == 3 ? 'Done' : currentStep === 2 && showFlowChart === true ? 'Confirm' : 'Next'" :disabled="!canProceed" @click="nextStep"></VButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Reconnect Confirmation Dialog -->
    <VDialog :open="showReconnectDialog" headline="Reconnect Account" modal @close="showReconnectDialog = false">
      <template #body>
        <p class="vtext-body">This appears to be previously disconnected account, connecting this will show the data associated with that connection. Do you want to proceed?</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="No" @click="showReconnectDialog = false; previousStep();"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="showReconnectDialog = false; reconnectAccount();"></VButton>
      </template>
    </VDialog>
  </div>
</template>

<script>
import apiInterceptor from '@/shared/apiInterceptor';
import { useUIStore } from '@/stores/ui';
import { environment } from '@/shared/env';
import { useAuthStore } from '@/stores/auth';
import { refreshChannel } from '@/composables/useConnectionVerification';

// `channelType` uses the API path segment, which differs from the verify API's
// channel slug for Google RCS.
const VERIFY_CHANNEL_BY_TYPE = {
  'whatsapp': 'whatsapp',
  'google-rcs': 'googlercs',
  'sms': 'sms',
  'email': 'email'
};

export default {
  name: 'ConnectChannel',
  emits: ['go-back'],
  props: {
    channelType: {
      type: String,
      default: null
    },
    onConnect: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      connecting: false,
      currentStep: 1,
      selectedChannel: null,
      formData: {},
      apikey: '',
      apisecret: '',
      privateKey: '',
      page_data: {},
      accounts: [],
      selectedAccount: null,
      showFlowChart: false,
      showApiSecret: false,
      showReconnectDialog: false
    };
  },
  computed: {
    canProceed() {
      if (this.currentStep === 1) {
        return this.apikey && this.apisecret && this.apikey.trim() !== '' && this.apisecret.trim() !== '';
      }
      if (this.currentStep === 2) {
        return this.accounts.some(account => account.selected);
      }
      return true;
    }
  },
  methods: {
    async nextStep() {
      if (!this.canProceed) return;
      
      if (this.currentStep === 1) {
        // Call API for authenticating before proceeding
        await this.authenticateApiCredentials();
      }
      else if (this.currentStep === 2) {
        if(this.showFlowChart === true){
          this.init_callStep3API();
        }
        else{
          const selectedAccount = this.accounts.find(account => account.selected === true);
          if (selectedAccount) {
            if (selectedAccount.status) {
              this.showFlowChart = true;
            } else {
              this.init_callStep3API();
            }
          }
          else {
            this.init_callStep3API();
          }
        }
      }
      else if(this.currentStep === 3){
        let message = "";
        if(this.channelType === 'whatsapp'){
          message = "Your WhatsApp registration is done successfully!";
        }
        else if(this.channelType === 'google-rcs'){
          message = "Your Google RCS registration is done successfully!";
        }
        else if(this.channelType === 'sms'){
          message = "Your SMS registration is done successfully!";
        }

        useUIStore().updateToast({
          open: true,
          message: message,
          type: "success"
        })
        
        // Dispatch custom event to refresh LiveChatHome customers
        const refreshEvent = new CustomEvent("refresh-customers", {
          detail: { 
            action: "connect",
            channel: this.channelType,
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(refreshEvent);
        
        // Re-fetch the connections list and mirror it into the auth store, instead of
        // going through checkToken()'s ensureQueryData, which returns existing cached
        // data without re-fetching when staleTime is Infinity — leaving the parent
        // channel page state stale after linking an account.
        await useAuthStore().refreshSocialConnections();
        // A connection was just linked — re-check its verification status.
        await this.refreshVerification();
      }
    },
    /** Re-verifies the channel this flow just connected, if we can map it. */
    async refreshVerification() {
      const channel = VERIFY_CHANNEL_BY_TYPE[this.channelType];
      if (channel) {
        await refreshChannel(channel);
      }
    },
    async authenticateApiCredentials() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Verifying credentials...' });
        
        // Call API with credentials
        const response = await this.callStep1API();
        
        // If successful, populate accounts and proceed to step 2
        this.populateAccountsFromAPI(response);
        this.currentStep = 2;
        
      } catch (error) {
        // Stay on step 1 and show error
        useUIStore().updateToast({
          open: true,
          message: error.message || 'Failed to verify credentials. Please check your API key and secret.',
          type: "danger"
        });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async callStep1API() {     
      try {        
        const reqBody = {
          apikey: this.apikey,
          apisecret: this.apisecret
        }; 
        const response = await apiInterceptor.post(environment("VUE_APP_API_URL") + "social/v1/"+ this.channelType +"/accounts", reqBody);
        return response;
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger" });
        throw new Error(`Network error: ${error.message}`);
      }
    },
    populateAccountsFromAPI(response) {
      if(response.page_data){
        this.page_data = response.page_data;
      }
      if (response.accounts && response.accounts.length > 0) {
        // Update accounts with API response
        this.accounts = response.accounts.map(account => ({
          name: account.name,
          id: account.external_id,
          number: account.number,
          status: account.linked_to_app,
          selected: account.selected || false,
          business_id: account.business_id || null
        }));
        // Ensure at least one account is selected
        const hasSelected = this.accounts.some(account => account.selected);
        if (!hasSelected && this.accounts.length > 0) {
          this.accounts[0].selected = true;

          this.selectedAccount = this.accounts[0];
        }
      } else {
        // Handle empty accounts case
        useUIStore().updateToast({
          open: true,
          message: 'No accounts found for the provided credentials.',
          type: "warning"
        });
      }
    },
    async init_callStep3API() {
      useUIStore().updateLoading({ isLoading: true, message: 'Linking account...' });
      
      // Call API with credentials
      const response = await this.callStep3API();
      console.log(response);

      if(response.data === null && response.dialogMessage){
        this.loading = false;
        await this.showReconnectConfirmation();
        return;
      }

      this.selectedAccount = response;

      this.showFlowChart = false;
      this.currentStep++;
    },
    async callStep3API() {     
      try {    
        const selectedAccount = this.accounts.find(account => account.selected === true);

        const reqBody = {
          page_id: this.page_data.id.toString(), 
          external_id: selectedAccount.id,
          confirm: false
        };
        if(selectedAccount.status === true){
          reqBody.linked_to_app = true;
        }
        if(this.channelType === 'whatsapp'){
          reqBody.business_id = selectedAccount.business_id;
        }
        const response = await apiInterceptor.post(environment("VUE_APP_API_URL") + "social/v1/"+ this.channelType +"/"+ this.page_data.id +"/accounts", reqBody);
        return response;
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger" });
        throw new Error(`Network error: ${error.message}`);
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    previousStep() {
      if (this.currentStep > 1) {
        if(this.currentStep === 2 && this.showFlowChart) this.showFlowChart = false;
        else this.currentStep--;
      }
    },
    goBackToSelection() {
      // Emit event to parent to go back to selection step
      this.$emit('go-back');
      // Reset form data
      this.apikey = '';
      this.apisecret = '';
      this.privateKey = '';
      this.currentStep = 1;
    },
    selectAccount(index) {
      // Reset all selections
      this.accounts.forEach(account => {
        account.selected = false;
      });
      // Select the clicked account
      this.accounts[index].selected = true;

      this.selectedAccount = this.accounts[index];
    },
    toggleApiSecretVisibility() {
      this.showApiSecret = !this.showApiSecret;
    },
    async showReconnectConfirmation() {
      this.showReconnectDialog = true;
    },
    async reconnectAccount() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Reconnecting account...' });
        
        const selectedAccount = this.accounts.find(account => account.selected === true);
        const reqBody = {
          page_id: this.page_data.id.toString(), 
          external_id: selectedAccount.id,
          confirm: true  // Set to true to confirm reconnection
        };
        if(selectedAccount.status === true){
          reqBody.linked_to_app = true;
        }
        if(this.channelType === 'whatsapp'){
          reqBody.business_id = selectedAccount.business_id;
        }
        
        const response = await apiInterceptor.post(
          environment("VUE_APP_API_URL") + "social/v1/"+ this.channelType +"/"+ this.page_data.id +"/accounts", 
          reqBody
        );
        
        this.selectedAccount = response;
        this.showFlowChart = false;
        this.currentStep++;
        
      } catch (error) {
        useUIStore().updateToast({ 
          open: true, 
          message: error.message || "Failed to reconnect account", 
          type: "danger" 
        });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.steps {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  .step {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    font-size: 0.8rem;
    .text {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: var(--gray-04);
    }
    &.selected {
      .number {
        background-color: var(--purple);
        color: var(--white);
      }
      .text {
        color: var(--purple);
      }
    }
    .number {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background-color: var(--background-primary);
    }
  }
  .divider {
    border-bottom: 1px solid var(--background-primary);
    width: 45px;
  }
}
</style>
<style scoped>
.connect-channel-container {
  min-height: calc(100dvh - 160px);
  display: flex;
  flex-direction: column;
}
.channel-header {
  background: var(--white);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
}
.step-content {
  flex: 1;
}
.navigation-section {
  margin-top: auto;
}
.content-col {
  margin: 0 auto;
}

/* Accounts list (Step 2) */
.accounts-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.account-card {
  border: 1px solid var(--background-primary);
  border-radius: 5px;
  padding: 20px;
  background: var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}
.account-card:hover {
  border-color: var(--gray-01);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.account-card.selected {
  border-color: var(--purple);
  background-color: #f8f5ff;
}
.account-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.account-row,
.account-details {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  gap: 20px;
}
.sub-title {
  font-size: 14px;
  font-weight: 400;
  color: var(--gray-04);
}
.name, .id, .status {
  font-size: 14px;
  font-weight: 400;
  color: var(--black);
}
.radio-container {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

/* Progress Steps */
.progress-container {
  margin-bottom: 25px;
}

/* Navigation */
.navigation-buttons {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex100P {
  flex: 1;
}

/* Shared layout */
.headerContainer {
  border-bottom: 1px solid var(--background-primary);
  padding-bottom: 20px;
}
.custPaddingBottom {
  padding-bottom: 20px;
}
.marginBottom {
  margin-bottom: 20px;
}

/* Flowchart (Step 2 - linked account confirmation) */
.flowchart-container {
  padding: 2rem;
  position: relative;
  text-align: center;
}
.leftside-container {
  display: inline-block;
  text-align: right;
  padding-right: 40px;
  vertical-align: middle;
  position: relative;
}
.rightside-container {
  display: inline-block;
  text-align: left;
  padding-left: 40px;
  vertical-align: middle;
  position: relative;
}
.line1 {
  background-color: #8b5cf6;
  position: absolute;
  left: calc(100% - 40px);
  top: 16px;
  width: 40px;
  height: 1px;
}
.line2 {
  border-left: 1px dashed red;
  position: absolute;
  left: 0px;
  top: 19px;
  width: 1px;
  height: 35px;
}
.line3 {
  border-top: 1px dashed red;
  position: absolute;
  left: 0px;
  top: 16px;
  width: 35px;
  height: 1px;
}
.line3::after {
  content: '';
  position: absolute;
  right: -6px;
  top: -5px;
  width: 0;
  height: 0;
  border-left: 8px solid red;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
}
.line4 {
  background-color: #8b5cf6;
  position: absolute;
  left: 0px;
  bottom: 16px;
  width: 1px;
  height: 35px;
}
.line5 {
  background-color: #8b5cf6;
  position: absolute;
  left: 0px;
  bottom: 16px;
  width: 35px;
  height: 1px;
}
.line5::after {
  content: '';
  position: absolute;
  right: -6px;
  top: -4px;
  width: 0;
  height: 0;
  border-left: 8px solid #8b5cf6;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
}
.box {
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-weight: 500;
  font-size: 0.8rem;
  text-align: center;
  display: inline-block;
  transition: all 0.3s ease;
}
.current-app {
  background-color: #f0f0f0;
  color: #333;
}
.account-name {
  background-color: #e8d5ff;
  color: #6b21a8;
}
.application {
  margin-top: 40px;
  background-color: #8b5cf6;
  color: white;
}
.question-text {
  margin-top: 3rem;
  text-align: center;
}
.warning {
  position: absolute;
  top: 6px;
  left: -3px;
  color: red;
}

/* Password input (Step 1) */
.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.password-input {
  flex: 1;
  padding-right: 40px !important;
}
.toggle-visibility-btn {
  position: absolute;
  right: 8px;
  z-index: 10;
  cursor: pointer;
}
.toggle-visibility-btn:hover {
  color: var(--purple);
}

/* Form inputs background */
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}

/* Responsive */
@media (max-width: 768px) {
  .flowchart-container {
    padding: 1rem;
  }
  .navigation-buttons {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
